import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { RouterModule } from '@angular/router';
import { DLHomeComponent } from './dl-home.component';
import { DLRootCertificateModule } from './root-certificate/root-certificate.module';
import { DLCompanyModule } from './company';
import { DLSettingsComponent } from './settings/settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DLSettingsService } from './settings/settings.service';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    DLRootCertificateModule,
    DLCompanyModule,
  ],
  declarations: [
    DLHomeComponent,
    DLSettingsComponent,
  ],
  providers: [
    DLSettingsService,
  ],
})
export class DLModule { }
